module.exports = __webpack_public_path__ + "static/media/prototype1.23af804b.jpg";